/*
 * @Author: edconstdchen
 * @Date:   2016-02-26 14:25:54
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-12-08 16:04:56
 */

const _ = require('lodash');

function text(str) {
  return str;
}

function strong(str) {
  return `<p><strong>${str}</strong></p>`;
}

function imageText(str) {
  return `<div class="x-img-desc">${str}</div>`;
}

function link(str) {
  let url = str;
  let title = '';
  if (str.indexOf('|#|') > -1) {
    const tmp = str.split('|#|');
    url = tmp[0];
    title = tmp[1];
  }
  return `<a href="${_.escape(url)}">${title}</a>`;
}

exports.text = text;
exports.strong = strong;
exports.imageText = imageText;
exports.link = link;

exports.video = require('./video');
exports.image = require('./image');
exports.iframeVideo = require('./iframe-video');

exports.globalJS = require('./globalMethods.ejs');



// WEBPACK FOOTER //
// ./src/HTMLTag/index.js